import { createElement } from 'react'

export type Props = {
  hTag: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
} & React.HTMLAttributes<HTMLHeadingElement>

export default function Heading({ hTag, children, ...props }: Props) {
  const Heading = createElement(hTag, props, children)
  return Heading
}
